import { render, staticRenderFns } from "./OpecOrders.vue?vue&type=template&id=76609c2a&scoped=true"
import script from "./OpecOrders.vue?vue&type=script&lang=js"
export * from "./OpecOrders.vue?vue&type=script&lang=js"
import style0 from "./OpecOrders.vue?vue&type=style&index=0&id=76609c2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76609c2a",
  null
  
)

export default component.exports